module.exports = __webpack_public_path__ + "img/user-minus.703c1f6d.svg";